import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import { sanity } from "../../lib/sanityClient";
import SectionTitle from "../SectionTitle";

const query = `*[_type == "post"] 
  | order(coalesce(publishedAt, _createdAt) desc){
    _id,
    title,
    "slug": slug.current,
    "publishedAt": coalesce(publishedAt, _createdAt),
    // supports either referenced categories or string tags
    "tags": select(
      defined(categories) => categories[]->title,
      defined(tags) => tags,
      [] // fallback empty array
    ),
    // optional: your short blurb
    "tagline": coalesce(description, summary)
}`;

function formatDate(iso) {
  return new Date(iso).toLocaleDateString(undefined, {
    year: "numeric", month: "short", day: "numeric"
  });
}

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    sanity.fetch(query)
      .then(data => { setPosts(data); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, []);

  return (
    <section className="blog-section">
      <Container>
        <SectionTitle number={3} title="Blog" />

        {loading && <p style={{ textAlign: "center", color: "#888" }}>Loading...</p>}
        {error && <p style={{ textAlign: "center", color: "red" }}>Error: {error}</p>}
        {!loading && !error && posts.length === 0 && (
          <p style={{ textAlign: "center", color: "#888" }}>No posts found.</p>
        )}

        <ul className="blog-list" style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {posts.map(p => (
            <li key={p._id} className="blog-item" style={{ padding: "1.25rem 0", borderBottom: "1px solid #eee" }}>
              <h2 className="blog-title" style={{ margin: 0 }}>
                <Link className="blog-link" to={`/blog/${p.slug}`}>{p.title}</Link>
              </h2>

              <div className="post-meta" style={{ color:"#555", fontSize:".95rem", marginTop:".25rem" }}>
                <span className="post-date" style={{ fontWeight: 600 }}>
                  {formatDate(p.publishedAt)}
                </span>
                {p.tagline ? <span style={{ margin: "0 .5rem", color:"#999" }}>•</span> : null}
                {p.tagline && <span className="post-summary">{p.tagline}</span>}
              </div>

              {p.tags?.length ? (
                <div className="tag-list">
                  {p.tags.map((t, i) => (
                    <span key={i} className="tag-pill">{t}</span>
                  ))}
                </div>
              ) : null}
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
